<!-- eslint-disable vuejs-accessibility/anchor-has-content -->
<template>
  <div
    v-if="signpost"
    :class="$blockClass(blockClass, 'signpost')"
  >
    <div class="navbar-signpost-images1">
      <div class="signpost-image1">
        <a
          v-if="
            signpost.link"
          :class="$blockClass(blockClass, 'signpost-link')"
          :href="signpost.link"
          :tabindex="isTabbable ? 0 : -1"
        >
          <responsive-image
            :image="signpost.image"
            min-max="200-500"
            :ratio="false"
          />
          <div
            class="text-div"
            :class="buttonPositionClass"
          >
            <p class="text-body-m-regular">{{ signpost.image_text }}</p>
            <a
              :class="`${$blockClass(blockClass, 'signpost-cta')} cta-button text-other-label-bold`"
              :href="signpost.cta_link"
            >{{ signpost.cta_button_name }}</a>
          </div>
        </a>
        <responsive-image
          v-else
          :image="signpost.image"
          min-max="200-500"
          :ratio="false"
        />
      </div>

      <div class="signpost-image2">
        <a
          v-if="signpost.link2"
          :class="$blockClass(blockClass, 'signpost-link')"
          :href="signpost.link2"
          :tabindex="isTabbable ? 0 : -1"
        >
          <responsive-image
            :image="signpost.image2"
            min-max="200-500"
            :ratio="false"
          />
          <div
            class="text-div"
            :class="buttonPositionClass2"
          >
            <p class="text-body-m-regular">{{ signpost.image2_text }}</p>
            <a
              :class="`${$blockClass(blockClass, 'signpost-cta')} cta-button text-other-label-bold`"
              :href="signpost.cta_link"
            >{{ signpost.cta_button2_name }}</a>
          </div>
        </a>
        <responsive-image
          v-else
          :image="signpost.image2"
          min-max="200-500"
          :ratio="false"
        />
      </div>
    </div>

    <div class="product-card-container">
      <div
        v-if="signpost.product_title"
        class="product-info"
      >
        <div
          class="product-title text-other-label-bold text-type"
          :style="productTitleStyle"
        >
          {{ signpost.product_title }}
        </div>
      </div>

      <div class="product-navigation-card">
        <div
          v-if="signpost.product"
          class="product-info"
        >
          <a :href="signpost.product.url">
            <responsive-image
              :image="signpost.product.image"
              min-max="200-500"
              :ratio="false"
            />
          </a>
          <div class="product-card__footer text-center product-nav-card-footer">
            <h2 class="product-card__title text-other-label-bold">
              {{ signpost.product.title }}
            </h2>
            <p class="product-prices product-card__prices">
              <span
                v-if="signpost.product.compare_at_price &&
                  signpost.product.compare_at_price > signpost.product.price"
                class="compare-at-price product-prices__compare-at-price text-other-sale-price"
              >
                {{ signpost.product.compare_at_price }}
              </span>

              <span
                v-if="signpost.product.price"
                class="price product-prices__price text-other-sale-price"
                :class="[
                  {
                    'product-prices__price--on-sale':
                      signpost.product.compare_at_price &&
                      signpost.product.compare_at_price > signpost.product.price
                  }
                ]"
              >
                {{ signpost.product.price }}
              </span>
            </p>
          </div>
        </div>

        <div
          v-if="signpost.product2"
          class="product-info"
        >
          <a :href="signpost.product2.url">
            <responsive-image
              :image="signpost.product2.image"
              min-max="200-500"
              :ratio="false"
            />
          </a>
          <div class="product-card__footer text-center product-nav-card-footer">
            <h2 class="product-card__title text-other-label-bold">
              {{ signpost.product2.title }}
            </h2>
            <p class="product-prices product-card__prices">
              <span
                v-if="signpost.product2.compare_at_price &&
                  signpost.product2.compare_at_price > signpost.product2.price"
                class="compare-at-price product-prices__compare-at-price text-other-sale-price"
              >
                {{ signpost.product2.compare_at_price }}
              </span>

              <span
                v-if="signpost.product2.price"
                class="price product-prices__price text-other-sale-price"
                :class="[
                  {
                    'product-prices__price--on-sale':
                      signpost.product2.compare_at_price &&
                      signpost.product2.compare_at_price > signpost.product2.price
                  }
                ]"
              >
                {{ signpost.product2.price }}
              </span>
            </p>
          </div>
        </div>

        <div
          v-if="signpost.product3"
          class="product-info"
        >
          <a :href="signpost.product3.url">
            <responsive-image
              :image="signpost.product3.image"
              min-max="200-500"
              :ratio="false"
            />
          </a>
          <div class="product-card__footer text-center product-nav-card-footer">
            <h2 class="product-card__title text-other-label-bold">
              {{ signpost.product3.title }}
            </h2>
            <p class="product-prices product-card__prices">
              <span
                v-if="signpost.product3.compare_at_price &&
                  signpost.product3.compare_at_price > signpost.product3.price"
                class="compare-at-price product-prices__compare-at-price text-other-sale-price"
              >
                {{ signpost.product3.compare_at_price }}
              </span>
              <span
                v-if="signpost.product3.price"
                class="price product-prices__price text-other-sale-price"
                :class="[
                  {
                    'product-prices__price--on-sale':
                      signpost.product3.compare_at_price &&
                      signpost.product3.compare_at_price > signpost.product3.price
                  }
                ]"
              >
                {{ signpost.product3.price }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Nav signpost (nav-signpost)
 * -----------------------------------------------------------------------------
 * Featured image and link for nav panel or drawer.
 * @param {Object} signpost - Featured image and link.
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {Boolean} isTabbable - Based on menu active state.
 */
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'NavSignpost',

  components: {
    ResponsiveImage,
  },

  props: {
    signpost: {
      type: Object,
      default: () => ({}),
    },
    blockClass: {
      type: String,
      default: '',
    },
    isTabbable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonPositionClass() {
      return this.signpost.button_position === 'below' ? 'button-below' : 'button-side'
    },
    buttonPositionClass2() {
      return this.signpost.button2_position === 'below' ? 'button-below' : 'button-side'
    },
    productTitleStyle() {
      return {
        color: this.signpost.product_title_color,
      }
    },
  },
}
</script>

<style lang="scss">
@import './nav-signpost';
</style>
